export default "__VITE_ASSET__GOZo7A_4__"